import { useState, useEffect } from 'react';
import { Box, Typography, Select, MenuItem, FormControl } from '@mui/material';
import { useTheme } from '@mui/material';
import { BaseButton } from '../../base';
import useProtectedClient from '../../../hooks/useProtectedClient';
import { updateMarketStatus } from '../../../api/admin/adminMarketApi';
import { useNotification } from '../../../context/NotificationProvider';

const MarketStatus = ({ marketId, isOpen, openingMode }) => {
    
    const statusOptions = ['باز', 'بسته'];
    const openingOptions = ['دستی', 'خودکار', 'با آنلاین'];
    const [status, setStatus] = useState(isOpen ? statusOptions[0] : statusOptions[1]); 
    const [opening, setOpening] = useState(openingOptions[openingMode.openingMode]);
    const [buttonLoading, setButtonLoading] = useState(false)
    const protectedClient = useProtectedClient();
    const {showNotification} = useNotification();

    const theme = useTheme();

    useEffect(() => {
        setStatus(isOpen ? statusOptions[0] : statusOptions[1]);
        setOpening(openingOptions[openingMode.openingMode]);
    }, [isOpen, openingMode]);

    const submitStatus = async () => {
        setButtonLoading(true);
        try {
            const sendingIsOpen = status === statusOptions[0]
            const sendingMode = openingOptions.findIndex(elm => elm === opening)
            const res = await updateMarketStatus(protectedClient, marketId, sendingIsOpen, sendingMode)
            showNotification(res.message, "success")
        } catch (error) {
            showNotification(error, "error");
        } finally {
            setButtonLoading(false);
        }
    }

    const handleStatusChange = (event) => {
        setStatus(event.target.value);
    };

    const handleOpeningChange = (event) => {
        setOpening(event.target.value);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                padding: '10px',
                margin: '12px',
                background: theme.palette.background.harmony
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                    marginBottom: '20px'
                }}
            >
                <BaseButton
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginLeft: 'auto',
                        marginRight: '8px',
                        borderRadius: '50px',
                        width: '30%',
                        height: '25px',
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                    }}
                    isLoading={buttonLoading}
                    onClick={submitStatus}
                >
                    <Typography variant='caption2'>
                        بروزرسانی
                    </Typography>
                </BaseButton>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '16px',
                }}
            >
                {/* Status Select */}
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Typography
                        variant='caption'
                        sx={{padding: '8px'}}
                    >وضعیت:</Typography>
                    <FormControl>
                        <Select
                            value={status}
                            onChange={handleStatusChange}
                            sx={{
                                minWidth: '60px',
                            }}
                        >
                            {statusOptions.map((option, index) => (
                                <MenuItem key={index} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>

                {/* Opening Select */}
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Typography
                        variant='caption'
                        sx={{padding: '8px'}}
                    >باز کردن:</Typography>
                    <FormControl>
                        <Select
                            value={opening}
                            onChange={handleOpeningChange}
                            sx={{
                                minWidth: "60px",
                            }}
                        >
                            {openingOptions.map((option, index) => (
                                <MenuItem key={index} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </Box>
        </Box>
    );
};

export default MarketStatus;
